module.exports = __webpack_public_path__ + "static/media/help_Perfil.797e7a4e.png";